document.addEventListener("DOMContentLoaded", function () {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon');
    const imgVPs = document.querySelectorAll('.img-vp');
    const closeButtons = document.querySelectorAll('.tooltip-close-button');
    const tooltipTexts = document.querySelectorAll('.tooltip-text');
    let currentTooltip = null;

    function closeAllTooltips() {
        tooltipTexts.forEach(tooltip => tooltip.style.display = 'none');
        currentTooltip = null;
    }

    function toggleTooltip(tooltipText) {
        if (!tooltipText) return;

        if (currentTooltip !== tooltipText) {
            closeAllTooltips();
            tooltipText.style.display = 'flex';
            currentTooltip = tooltipText;
        } else {
            tooltipText.style.display = 'none';
            currentTooltip = null;
        }
    }
    function hideTooltip(tooltipText) {
        if (tooltipText) {
            tooltipText.style.display = 'none';
            currentTooltip = null;
        }
    }
    function addTooltipToggleListener(elements, tooltipSelector) {
        elements.forEach(el => {
            if (!el) return;
            el.addEventListener('click', function () {
                const tooltipText = this.closest(tooltipSelector).querySelector('.tooltip-text');
                toggleTooltip(tooltipText);
            });
        });
    }

    addTooltipToggleListener(tooltipIcons, '.tooltip-content-vp');
    addTooltipToggleListener(imgVPs, '.value-props-wrapper_item');

    closeButtons.forEach(button => {
        button?.addEventListener('click', function () {
            const tooltipText = this.closest('.tooltip-text');
            hideTooltip(tooltipText);
        });
    });

    tooltipTexts.forEach(tooltipText => {
        tooltipText?.addEventListener('click', function (event) {
            if (event.target === tooltipText) {
                hideTooltip(tooltipText);
            }
        });
    });
});